import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddComponent } from './add/add.component';
import { ListForStudentComponent } from './list-for-student/list-for-student.component';
import { ListAdminComponent } from './list-admin/list-admin.component';

const routes: Routes = [
  {
    path:'list',component:ListAdminComponent
  },
  {
    path:'my-discussions',component:ListForStudentComponent
  },
  {
    path:'add', component:AddComponent
  },
  {
    path:'edit/:id', component:AddComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DiscussionRoutingModule { }
